import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { classNames } from 'primereact/utils';
import { Divider } from 'primereact/divider';
import React, { Component } from 'react'
import { baseUrlAdmin } from '../store/apiConstants';
import Service from '../services/index';


const searchTypeOptions = [
    { label: "Student Name", value: "studentName" },
    { label: "Enrollment Number", value: "enrollmentNumber" }
]

class ClassetStudentSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchType: searchTypeOptions[0].value,
            searchValue: "",
            focused: false,
            studentInfo: []
        };
        this.service = new Service(); // Initialize service
    }

    // componentDidMount() {
    //     this.getStudentsInfo();
    //     // Check if selectedValue prop has changed
    //     if (prevProps.selectedValue !== this.props.selectedValue) {
    //         // Clear the search value
    //         this.setState({
    //             searchValue: "",
    //             focused: false
    //         });
    //         this.props.handleSearchValue("");
    //     }

    // }

    componentDidMount() {
        this.getStudentsInfo();
    }

    componentDidUpdate(prevProps) {
        // Check if selectedValue prop has changed
        if (prevProps.selectedValue !== this.props.selectedValue) {
            // Clear the search value
            this.setState({
                searchValue: "",
                focused: false
            });
            this.props.handleSearchValue("");
        }
    }

    getStudentsInfo = () => {
        const payload = {
            orgId: localStorage.getItem('orgId'),
            academicYear: localStorage.getItem('userAcademicYear')
        }

        const url = `${baseUrlAdmin}/students/student-information`;

        this.service.post(url, payload, true)
            .then(response => {
                console.log('Student Info Response:', response);

                if (response?.res?.status && response?.res?.data.data) {
                    // Ensure we're setting an array
                    const studentData = Array.isArray(response.res.data.data) ? response.res.data.data : [];
                    this.setState({
                        studentInfo: studentData
                    });
                } else {
                    // Set empty array if no data
                    this.setState({
                        studentInfo: []
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching student information:', error);
                // Set empty array on error
                this.setState({
                    studentInfo: []
                });
            });
    };

    handleTypeChange = (value) => {
        this.setState({ searchType: value });
        this.props.handleTypeValue(value);
    }


    handleValueChange = (value) => {
        // Set empty string if value is null (when cleared)
        const newValue = value === null ? "" : value;
        this.setState({ searchValue: newValue });
        this.props.handleSearchValue(newValue);
    }

    // Add after handleValueChange method
    // handleBlur = () => {
    //     this.setState({ searchValue: "" });
    //     this.props.handleSearchValue("");
    //     this.setState({ focused: false });
    // }

    handleBlur = (event) => {
        // Only clear if the related target is a dropdown option
        if (event.relatedTarget && event.relatedTarget.classList.contains('p-dropdown-item')) {
            this.setState({
                searchValue: "",
                focused: false
            });
            this.props.handleSearchValue("");
        }
    }


    render() {
        const { searchType, searchValue, focused, studentInfo } = this.state;
        const { selectedValue } = this.props;

        return (
            <div className="flex">
                <div style={{ width: "660px", height: "48px" }}
                    className={classNames('p-inputgroup', 'custom-input-group', `border-300 shadow-2 border-round-lg flex justify-content-center align-items-center`, { 'custom-input-focused': focused })}
                >
                    <Dropdown
                        optionLabel='label'
                        style={{ width: "171px", height: "48px" }}
                        optionValue='value'
                        className='pr-2 text-xl pl-2 no-border border-none pt-2'
                        value={searchType}
                        disabled={selectedValue === 1}
                        options={searchTypeOptions}
                        onChange={(e) => this.handleTypeChange(e.target.value)}
                        placeholder={(
                            <div className="flex justify-content-start align-items-center">
                                <span className='text-xl'>Select Type</span>
                            </div>
                        )}
                    />
                    <Divider layout="vertical" />

                    <span className="p-inputgroup-addon pl-3">
                        <i className="pi pi-search pt-2 px-3 text-2xl"></i>
                    </span>

                    {searchType === "enrollmentNumber" ? (
                        <Dropdown
                            optionLabel={(option) => option.enrollmentId || (option.user_info && option.user_info.enrollmentId) || ''}
                            filter
                            showClear
                            dropdownIcon={false}
                            style={{ width: "171px", height: "48px" }}
                            optionValue='user_id'
                            className='pr-2 text-xl pl-2 no-border border-none pt-2'
                            value={searchValue}
                            disabled={selectedValue === 1}
                            options={studentInfo}
                            onChange={(e) => this.handleValueChange(e.target.value)}
                            onBlur={this.handleBlur}

                            placeholder="Search Enrollment Number"
                        />
                    ) : (
                        <Dropdown
                            optionLabel={(option) => {
                                const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                                return option.user_info.firstName && option.user_info.lastName ?
                                    `${capitalize(option.user_info.firstName)} ${capitalize(option.user_info.lastName)}` :
                                    capitalize(option.user_info.given_name)
                            }}
                            dropdownIcon={false}
                            filter
                            showClear
                            style={{ width: "171px", height: "48px" }}
                            optionValue='user_id'
                            className='pr-2 text-xl pl-2 no-border border-none pt-2'
                            value={searchValue}
                            disabled={selectedValue === 1}
                            options={studentInfo}
                            onChange={(e) => this.handleValueChange(e.target.value)}
                            onBlur={this.handleBlur}

                            placeholder="Search Student Name"
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default ClassetStudentSearch;